<template>
  <div class="energy-left-box">
    <div class="left-box-left">
      <div class="left-box-left-1">
        <Com_1></Com_1>
      </div>
      <div class="left-box-left-2">
        <Com_2></Com_2>
      </div>
      <div class="left-box-left-3">
        <Com_3></Com_3>
      </div>
    </div>
  </div>
</template>

<script>
import Com_1 from "@/views/components/smart3/Com_4.vue";
import Com_2 from "@/views/components/smart3/Com_5.vue";
import Com_3 from "@/views/components/smart3/Com_6.vue";
export default {
  components: {
    Com_1,
    Com_2,
    Com_3,
  },
  data() {
    return {};
  },

  mounted() {},
  deleted() {
    window.onresize = null;
  },
  methods: {},
  destroyed() {},
};
</script>

<style scoped lang="scss">
.energy-left-box {
  width: 470px;
  height: 1080px;
  // margin-top: 100px;
  display: flex;
  justify-content: space-between;
  padding-right: 30px;

  .left-box-left {
    width: 440px;
    height: 1080px;

    .left-box-left-1 {
      width: 440px;
      height: 300px;
    }

    .left-box-left-2 {
      // margin-top: 50px;
      width: 440px;
      height: 330px;
      // background-color: salmon;
    }

    .left-box-left-3 {
      // margin-top: 50px;
      width: 440px;
      height: 330px;
      // background-color: brown;
    }
  }

  //   .left-box-right {
  //     width: 440px;
  //     height: 1470px;

  //     .left-box-right-1 {
  //       width: 440px;
  //       height: 280px;
  //       // background-color: violet;
  //     }

  //     .left-box-right-2 {
  //       margin-top: 50px;
  //       width: 440px;
  //       height: 550px;
  //       // background-color: grey;
  //     }

  //     .left-box-right-3 {
  //       margin-top: 50px;
  //       width: 440px;
  //       height: 387px;
  //       // background-color: gainsboro;
  //     }
  //   }
}
</style>
